<template>
  <div class="mse-sign">
    <div id="big-sign">
      <div id="main-sign">
        <div class="study-sgin">
          交道学习流程
        </div>
      </div>

      <div id="main-sign">
        <div class="study-sgin-az">
          ①安卓手机学习
        </div>
        <div class="study-sgin-img">
          <img src="../../../assets/img/signUp/qr.jpeg">
        </div>
      </div>

      <div id="main-sign">
        <div class="study-sgin-az">
          ②微信小程序学习（适用于安卓、ios）
        </div>
        <div class="study-sgin-img">
          <img src="../../../assets/img/signUp/WechatIMG1965.jpeg">
        </div>
      </div>

      <div id="main-sign">
        <div class="study-sgin-az">
          ③如有问题请联系客服电话
          <p style="color: #c72e2e;font-size: 0.4rem">手机：17611422399</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request';
import {Dialog, Notify} from "vant";
export default {
  components: {
  },
  data() {
    return {
      type:'',
    };
  },
  created() {
  },

  methods: {

  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.study-sgin-img{
  text-align: center
}
.study-sgin-img img{
  text-align: center;
  width: 4rem;
}
.study-sgin{
  margin-top: 20px;
  background: #fff;
  text-align: center;
  font-size: 0.4rem;
  font-weight: bold;
  color: red;
}
.study-sgin-az{
  margin-top: 20px;
  background: #fff;
  text-align: center;
  font-size: 0.35rem;
  font-weight: bold;
}
.account-sp{
  color: red;
  font-size: 0.35rem
}
.account-sign{
  float: right;
  margin-right: 0.5rem
}
.button-ce-s{
  width: 100%;
  text-align: center
}
.button-sign{
  height: 0.78667rem;
  line-height: .78667rem;
  padding: 0 0.73333rem;
  font-size: .28333rem;
  background-color: #1e9fff;
  margin-bottom: 1rem;
  border: none;
  color: #ffff;
  font-weight: bold;
  margin-top: 0.3rem;
}
.img-but{
  margin-bottom: 0.5rem!important;
}
.img-sign{
  margin-left: 2.38rem;
  width: 4rem;
  margin-top: -0.8rem;
}
.select-sgin{
  width: 70%;
  border: none;
  font-size: .28rem;
  height: 100%;
  background-color: #ffff;
}
.mse-sign {
  #big-sign {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #f9f9f9;
  }

  #imgFanhui {
    display: block;
    width: 0.2rem;
    height: 0.36rem;
    position: absolute;
    left: 0.3rem;
    top: 0.26rem;
  }

  #header {
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background: #383952;
    text-align: center;
    font-size: 0.36rem;
    font-weight: 400;
    color: #fff;
  }

  #main-sign {
    flex: 1;
    background: #ffffff;
    overflow-y: auto;
  }

  #nav {
    width: 100%;
    // height: 2rem;
    background: #fff;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  #nav p {
    /*float: left;*/
    display: inline-block;
    width: 1.46rem;
    height: 0.68rem;
    line-height: 0.68rem;
    text-align: center;
    font-size: 0.36rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    border: 1px solid rgba(50, 51, 51, 1);
    margin: 0.32rem 0 0.2rem 0.72rem;
  }

  .ys {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  .ys1 {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  .ys2 {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  #money {
    width: 100%;
    height: auto;
    background: #fff;
    margin-bottom: 0.2rem;
  }

  #money p {
    width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    border-bottom: 1px solid rgba(205, 205, 205, 1);
    margin: 0 auto;
  }

  #money p a {
    float: left;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }

  #money p span {
    float: right;
    font-size: 0.32rem;
    font-weight: 400;
  }

  #money p span a {
    color: rgba(51, 51, 51, 1);
  }

  #need {
    color: rgba(255, 180, 0, 1) !important;
  }

  #btn {
    width: 92.5%;
    height: 0.82rem;
    line-height: 0.82rem;
    background: #f63c45;
    border-radius: 4px;
    margin: 0 auto;
    margin-top: 0.88rem;
    text-align: center;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    font-size: 0.34rem;
    margin-bottom: 0.2rem;
    cursor: pointer;
    overflow: hidden;
  }
  #showTime {
    font-size: 0.32rem;
    line-height: 0.72rem;
    padding-left: 0.7rem;
  }

  .table-main-sign {
    width: 100%;
    height: auto;
    background: #fff;
  }
  .table-main-sign1-sign {
    width: 100%;
    height: auto;
    background: #fff;
    overflow: hidden;
    margin-bottom: 0.3rem;
  }
  .table-main-sign p {
    width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    border-bottom: 1px solid rgba(205, 205, 205, 1);
    margin: 0 auto;
    overflow: hidden;
  }

  .table-main-sign p a {
    float: left;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }

  .table-main-sign p span {
    float: right;
    font-size: 0.32rem;
    font-weight: 400;
  }

  .table-main-sign p span a {
    color: rgba(51, 51, 51, 1);
  }
  .fp {
    display: block;
    width: 1.52rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }
  .fp:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fp11 {
    display: block;
    width: 1.52rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }

  .fpss {
    display: block;
    width: 2.8rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-bottom: 0.26rem;
    margin-left: 0.3rem;
    border-radius: 4px;
  }
  .fpss1 {
    display: block;
    width: 2.8rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-bottom: 0.26rem;
    margin-right: 0.3rem;
    border-radius: 4px;
  }
  .fpss:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fpss1:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fpxx {
    display: block;
    width: 2.5rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }
  .fpxx:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fps {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .table-kfp {
    height: 0.88rem;
    width: 100%;
    background: #f3f3f4;
  }
  .table-kfp p {
    width: 92.5%;
    height: 0.88rem;
    line-height: 0.88rem;
    margin: 0 auto;
    font-size: 0.32rem;
    color: #666666;
  }
  .table-main-sign1-sign p {
    width: 99.5%;
    height: 0.8rem;
    line-height: 0.8rem;
    border: 0.02rem solid #e6e6e6;
    margin: 0 auto;
  }

  .table-main-sign1-sign p a {
    float: left;
    font-size: .28rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333;
    width: 1.8rem;
    text-align: center;
    /* height: 0.5rem; */
    height: 100%;
    border-right: .02rem solid #e6e6e6;
    background-color: #FBFBFB;
  }
  .table-main-sign1-sign p span {
    float: left;
    font-size: 0.32rem;
    font-weight: 400;
    margin-left: 0.5rem;
  }

  .table-main-sign1-sign p span a {
    color: rgba(51, 51, 51, 1);
  }
  .inputs-t {
    float: none;
    width: 5.2rem;
    height:99%;
    line-height: 99%;
    color: #666;
    text-align: left;
    font-size: .28rem;
    border: none;
    margin-left: .06rem;
  }
  .van-cell {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    margin: 0 auto;
    box-sizing: border-box;
    width: 92.5%;
    /* padding: .13333rem .21333rem; */
    overflow: hidden;
    color: #323233;
    font-size: 0.32rem !important;
    line-height: 0.32rem;
    background-color: #fff;
    padding: 0.3rem 0;
    border: none !important;
    border-bottom: 1px solid rgba(205, 205, 205, 1);
  }
  #gs {
    position: absolute;
    font-size: 0.32rem;
    z-index: 99999;
    right: 0.8rem;
    top: 0.26rem;
  }
  .van-collapse-item__content {
    padding: 0 !important;
    color: #969799;
    font-size: 0.32rem !important;
    line-height: 1.5;
    background-color: #fff;
  }
  input {
    background: #fff;
    border: none;
  }
  input[type='radio'] + label::before {
    content: '\a0'; /*不换行空格*/
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    width: 1em;
    height: 1em;
    margin-right: 0.4em;
    border-radius: 50%;
    border: 1px solid #01cd78;
    text-indent: 0.15em;
    line-height: 1;
  }
}
</style>
